var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.103 2.677A7.035 7.035 0 0 0 7.096.603c-1.892 0-3.67.736-5.007 2.074A7.035 7.035 0 0 0 .015 7.684c0 3.826 3.618 7.009 5.561 8.718.27.238.504.443.69.617.232.217.531.326.83.326.299 0 .598-.109.83-.326.186-.174.42-.379.69-.617 1.943-1.71 5.561-4.892 5.561-8.718 0-1.892-.737-3.67-2.074-5.007zm-4.135 12.99c-.276.242-.515.452-.711.635a.237.237 0 0 1-.322 0c-.197-.183-.435-.393-.711-.636C4.397 14.06.995 11.066.995 7.684c0-3.364 2.737-6.1 6.1-6.1 3.365 0 6.101 2.736 6.101 6.1 0 3.383-3.401 6.375-5.228 7.982z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.096 4.296c-1.72 0-3.12 1.4-3.12 3.12 0 1.721 1.4 3.12 3.12 3.12 1.72 0 3.12-1.399 3.12-3.12 0-1.72-1.4-3.12-3.12-3.12zm0 5.26c-1.18 0-2.14-.96-2.14-2.14 0-1.18.96-2.14 2.14-2.14 1.18 0 2.14.96 2.14 2.14 0 1.18-.96 2.14-2.14 2.14z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.ddea2dc81bb2a98ec259b913b7257ee0.svg";
export { ForwardRef as ReactComponent };